import { render, staticRenderFns } from "./DatesClosed.vue?vue&type=template&id=06945214"
import script from "./DatesClosed.vue?vue&type=script&lang=js"
export * from "./DatesClosed.vue?vue&type=script&lang=js"
import style0 from "./DatesClosed.vue?vue&type=style&index=0&id=06945214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports